import { render, staticRenderFns } from "./VValidate.vue?vue&type=template&id=0f2ef0e0&"
import script from "./VValidate.vue?vue&type=script&lang=js&"
export * from "./VValidate.vue?vue&type=script&lang=js&"
import style0 from "./VValidate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports